import {React} from 'external/react'
import {styled, Box, FormHelperText, FormControl, OutlineInput} from 'external/material'
import {pickAttributes} from 'helpers/utils'

const StyledTextInput = styled(Box)(textStyles)

export default function TextInput(props) {
  const errorId = `${props.id}-error-text`
  return (
    <StyledTextInput className={props?.customClassName ?? ''}>
      <Box className="label">{props.caption}</Box>
      <Box className="input">
        <FormControl
          {...pickAttributes(props, 'control')}
          className="control"
        >
          <OutlineInput
            id={props.id}
            aria-describedby={errorId}
            value={props.value}
            {...pickAttributes(props, 'input')}
            className="input"
          >
          </ OutlineInput>
          <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
        </FormControl>
      </Box>
    </StyledTextInput>
  )
}

function textStyles() {
  return {
    "& .control": {
      margin: 0,
      flexGrow: 1
    },
    "& .input": {
      "& input": {
        padding: 10
      }
    }
  }
}
